// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HHHhoVDNAyzfOEe89lCo{align-items:center;background:rgba(var(--theme-body-background-color--rgb), 0.3);border-bottom:3px solid var(--theme-accent-color, #7638bb);display:flex;height:100px;justify-content:center;width:100px}@media only screen and (min-width: 768px){.HHHhoVDNAyzfOEe89lCo{width:150px}}.acBtnXVBZX2hrE3QZF_E{align-items:center;background-color:var(--theme-accent-color, #000);border-radius:50%;display:flex;height:48px;justify-content:center;width:48px}.acBtnXVBZX2hrE3QZF_E>svg{fill:var(--theme-accent-label-color, #fff)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"noImageWrapper": `HHHhoVDNAyzfOEe89lCo`,
	"iconWrapper": `acBtnXVBZX2hrE3QZF_E`
};
export default ___CSS_LOADER_EXPORT___;
